import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import services from 'services';
import selectors from 'state/selectors';
import utils from 'utils';
import { ACTIONTYPE } from 'utils/constants';

const useCheckBeforeAction = (action: ACTIONTYPE) => {
  const isDocumentOpen = window.location.href.includes('edit');
  const idUser = useSelector(selectors.user.getUserName) ?? '';
  const notify = utils.app.notify;
  const translate = utils.app.textTranslated;
  const t = utils.intl.useTranslator();
  const userCompanies = useSelector(selectors.app.getCompanies);

  const checkDocuments = useCallback(
    async (priorAction?: ACTIONTYPE) => {
      const protocolsToBeCheckBeforeAction = utils.user.actionNeedToCheck(priorAction ?? action);
      if (protocolsToBeCheckBeforeAction.length === 0) {
        return true;
      }

      const firstCompanyId = protocolsToBeCheckBeforeAction[0].idCompany;
      const areSameCompany = protocolsToBeCheckBeforeAction.every((row) => row.idCompany === firstCompanyId);

      const protocols = protocolsToBeCheckBeforeAction.map((row) => row.protocol);
      const company = userCompanies.find((c) => c.idCompany === firstCompanyId);
      const actionFind = company?.actions.find((a) => a.type === action);

      const idAction = actionFind?.sendForDocAvailability ? actionFind.idAction : null;
      const { data } = await services.checkDocumentAvailability(
        protocols,
        idUser,
        isDocumentOpen,
        areSameCompany ? firstCompanyId : null,
        idAction,
      );
      const notAvailableDocs = data.documents.filter((result: { available: boolean }) => result.available === false);
      if (notAvailableDocs.length !== 0) {
        notAvailableDocs.forEach(({ message, messageKey }) => {
          notify('fail', translate(message, t, messageKey));
        });
        return false;
      }
      return true;
    },
    [action, idUser, isDocumentOpen, notify, translate, t, userCompanies],
  );

  return { checkDocuments };
};

export default useCheckBeforeAction;
